import { render } from "./TopBarContainer.vue?vue&type=template&id=85f21202"
import script from "./TopBarContainer.vue?vue&type=script&lang=js"
export * from "./TopBarContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__